import { useEffect } from "react";
import ModalWrapper from "../ModalWrapper";

import ModalPersonalDataBodyNew from "./ModalPersonalDataBodyNew";

const ModalPersonalData = ({
    isOpen,
    onCloseModal,
    onComplete,
    selectedModel,
    selectedVersion,
    clientData,
    preselectedDealershipId,
}) => {
    useEffect(() => {
        if (isOpen) {
            const scrollY = window.scrollY;
            
            document.body.classList.add("hide-float-buttons");
            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollY}px`;
            document.body.style.width = '100%';
            document.body.style.overflow = 'hidden';
            
            const configurator = document.querySelector('.configurator');
            if (configurator) {
                configurator.style.overflow = 'hidden';
                configurator.style.height = '100vh';
            }

            return () => {
                document.body.classList.remove("hide-float-buttons");
                document.body.style.position = '';
                document.body.style.top = '';
                document.body.style.width = '';
                document.body.style.overflow = '';
                
                if (configurator) {
                    configurator.style.overflow = '';
                    configurator.style.height = '';
                }
                
                window.scrollTo(0, scrollY);
            };
        }
    }, [isOpen]);

    return (
        <ModalWrapper isOpen={isOpen} cssClass="modal-personal-data">
            <ModalPersonalDataBodyNew
                onCloseModal={onCloseModal}
                onComplete={onComplete}
                selectedModel={selectedModel}
                selectedVersion={selectedVersion}
                clientData={clientData}
                preselectedDealershipId={preselectedDealershipId}
            />
        </ModalWrapper>
    );
};

export default ModalPersonalData;
